// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2Ajf-","Success":"Button_Success__34PY3","Danger":"Button_Danger__2nfno"};